/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscanerrorunavailable3Inputs */

const en_menuscanerrorunavailable3 = /** @type {(inputs: Menuscanerrorunavailable3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading menus is not available right now. Enter the menu yourself.`)
};

const de_menuscanerrorunavailable3 = /** @type {(inputs: Menuscanerrorunavailable3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Einlesen ist gerade nicht verfügbar. Trag das Menü selbst ein.`)
};

/**
* | output |
* | --- |
* | "Reading menus is not available right now. Enter the menu yourself." |
*
* @param {Menuscanerrorunavailable3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscanerrorunavailable3 = /** @type {((inputs?: Menuscanerrorunavailable3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscanerrorunavailable3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscanerrorunavailable3(inputs)
	return de_menuscanerrorunavailable3(inputs)
});
export { menuscanerrorunavailable3 as "menuScanErrorUnavailable" }